import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { Webcam } from 'src/app/maps/domain/masterdata/webcam.model';
import { MapStyleService } from 'src/app/maps/map/style/map-style.service';

@Component({
  selector: 'sis-webcam-modal',
  templateUrl: './webcam-modal.component.html',
  styleUrls: ['./webcam-modal.component.scss'],
  standalone: false,
})
export class WebcamModalComponent implements OnInit {
  @Input() readonly webcam: Webcam;

  webcamUrl: SafeResourceUrl;
  useIFrame: boolean;
  showSpinner = true;
  className: string;
  spinnerColor: string;

  constructor(
    private modalCtrl: ModalController,
    private sanitizer: DomSanitizer,
    private mapStyleService: MapStyleService,
    private cdr: ChangeDetectorRef,
  ) {}

  async ngOnInit(): Promise<void> {
    this.useIFrame = this.webcam.type === Webcam.iframe;
    this.webcamUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${this.webcam.url}?${Math.floor(Math.random() * 10000).toString()}`,
    );
    const styleName = await this.mapStyleService.getStyleName();
    this.className = `sis-webcam-modal-${styleName}`;
    this.spinnerColor = styleName === 'andermatt' ? 'dark' : 'secondary';
    this.cdr.detectChanges();
  }

  closeModal(): void {
    this.modalCtrl.dismiss();
  }

  hideSpinner(): void {
    this.showSpinner = false;
  }
}
